import * as React from 'react';

function SvgIconLogoAdserve(props) {
    return (
        <svg
            id='icon-logo-adserve'
            width={40}
            height={40}
            viewBox='0 0 50 39.23'
            {...props}
        >
            <path
                fill='#414141'
                d='M29.32,26.42l.16-7.07h-.29V16.19l-2.51.54a9.41,9.41,0,0,0,1.88-6A9.24,9.24,0,0,0,24.63,3a16.32,16.32,0,0,0-10-3Q8.17,0,4.25,3.05a10,10,0,0,0-3.79,8.6l.06.16H9A4.81,4.81,0,0,1,10.42,7.9a6.56,6.56,0,0,1,4.35-1.22,5.5,5.5,0,0,1,3.74,1.18,3.65,3.65,0,0,1,1.37,2.9,3.16,3.16,0,0,1-1.4,2.69A27.51,27.51,0,0,1,13.23,16a27.78,27.78,0,0,0-9.88,4.8A9.61,9.61,0,0,0,0,28.52a9.23,9.23,0,0,0,3.87,7.87q3.87,2.84,10.26,2.84a18.56,18.56,0,0,0,10.79-3l.08-.06.08.06a16.61,16.61,0,0,0,5.83,2.52l0-7.55Q29.33,29.76,29.32,26.42ZM8.72,28.57A3.83,3.83,0,0,1,10,25.44a17.15,17.15,0,0,1,4.77-2.32,54.13,54.13,0,0,0,6-2.35l0,3.7-.12,2q0,3.33-1.61,4.73a7.41,7.41,0,0,1-4.94,1.4,6.34,6.34,0,0,1-4.07-1.1A3.52,3.52,0,0,1,8.72,28.57Z'
            />
            <path
                fill='#e39636'
                d='M24.82,18.21q3.39,2.61,10.38,4.91A17.15,17.15,0,0,1,40,25.44a3.83,3.83,0,0,1,1.31,3.13,3.52,3.52,0,0,1-1.34,2.88,6.34,6.34,0,0,1-4.07,1.1,7.41,7.41,0,0,1-4.94-1.4V38.7a22.23,22.23,0,0,0,4.95.53q6.39,0,10.26-2.84A9.23,9.23,0,0,0,50,28.52a9.61,9.61,0,0,0-3.35-7.75A27.78,27.78,0,0,0,36.77,16a27.51,27.51,0,0,1-5.25-2.52,3.16,3.16,0,0,1-1.4-2.69,3.65,3.65,0,0,1,1.37-2.9,5.5,5.5,0,0,1,3.74-1.18A6.56,6.56,0,0,1,39.58,7.9,4.81,4.81,0,0,1,41,11.81h8.45l.06-.16a10,10,0,0,0-3.79-8.6Q41.82,0,35.41,0a16.32,16.32,0,0,0-10,3,9.24,9.24,0,0,0-3.94,7.75A8.87,8.87,0,0,0,24.82,18.21Z'
            />
        </svg>
    );
}

const MemoSvgIconLogoAdserve = React.memo(SvgIconLogoAdserve);
export default MemoSvgIconLogoAdserve;
